// Conversion name for permission key: first part is module, second submodule.
// Example: 'account.whitelist_ip' permission key will be created based on conversion + dot will be replaced to double underscore "__". [Module]__[Submodule] (ACCOUNT__WHITELIST_IP)
export const TENANTS = 'tenants';
export const USERS = 'users';
export const ASSETS_MGMT = 'assets_mgmt';
export const ASM_ASSETS_MGMT = 'asm_assets_mgmt';
export const DATA_LAKE = 'data_lake';
export const FORENSIC = 'forensic_canvas';
export const ASSETS_MGMT_OLD = 'assets_mgmt_old';
export const CYCLOPS = 'cyclops.token';
export const CAASM_ASM_INTEGRATION = 'asm_caasm_integration';
export const ALERTS = 'alerts';
export const ALERTS__DRAFT = 'alerts.draft';
export const ALERTS__POLICY = 'alerts.policy';
export const ALERTS__CONFIG = 'alerts.config';
export const CHANGE_ALERT_STATUS = 'alerts.status';
export const ACCOUNT__MEANTIME = 'account.meantime';
export const ACCOUNT__SESSION_TIMEOUT = 'account.session_timeout';
export const ACCOUNT__WHITELIST_IP = 'account.whitelist_ip';
export const ACCOUNT__TAKEDOWN = 'account.takedown';
export const ACCOUNT__FEATURES = 'account.features';
export const ACCOUNT__SUB_ENVS = 'account.sub_envs';
export const TI__RECOMMENDED_QUERIES = 'threat_intelligence.recommended_queries';
export const TI__PREDEFINED_SAVED_QUERIES = 'threat_intelligence.predefined_saved_queries';
export const TI__SAVED_QUERY_CAPACITY = 'threat_intelligence.saved_query_capacity';
export const PANOPTES = 'panoptes';
export const LICENSE = 'license';
export const SF_AND_TH = 'sync_status';
// Backend permission `manage_uc_sync_status`. Sparse: present only for users allowed to toggle it.
export const USER_CENTER_SYNC = 'uc_sync';
export const MANAGE_ALERTS_TAGS = 'alerts.tags';
export const ALERT_COMMENTS = 'alerts.comment';
export const USER_LOGIN_EVENTS = 'users.login_events';
